import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/images/icon_trans.png'


const _hoisted_1 = { class: "menu-content" }
const _hoisted_2 = { class: "profile" }
const _hoisted_3 = { class: "nickname" }

import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";
import {
  IonContent,
  IonLabel,
  IonText,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonPage,
  IonRouterOutlet,
  IonMenu,
  menuController,
  IonIcon,
  IonImg,
  onIonViewDidLeave,
  modalController,
  onIonViewWillEnter,
  isPlatform,
} from "@ionic/vue";
import {
  bagHandleOutline,
  closeOutline,
  globeOutline,
  homeOutline,
  menuOutline,
  personCircleOutline,
  scanOutline,
} from "ionicons/icons";
import { useUserStore } from "@/store/modules/user";
import { useProductStore } from "@/store/modules/product";
import ModalBarcodeScanResult from "./Product/ModalBarcodeScanResult.vue";
import {
  BarcodeFormat,
  BarcodeScanner,
} from "@capacitor-mlkit/barcode-scanning";
import ScanView from "@/components/Modal/ScanView.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TabsPage',
  setup(__props) {

const shop_site = (path: string) => {
  window.location.href = path;
};
const router = useRouter();
const userStore = useUserStore();
const user = computed(() => userStore.user);
const path = computed(() => router.currentRoute.value.path);
const productStore = useProductStore();
const routes1 = computed(() => {
  return [
    {
      id: "home",
      label: "Home",
      icon: homeOutline,
      path: "/tabs/home",
    },
    {
      id: "explore",
      label: "Explore",
      icon: globeOutline,
      path: "/tabs/explore",
    },
  ];
});

const routes2 = computed(() => {
  return [
    {
      id: "mysku",
      label: "My SKU",
      icon: personCircleOutline,
      path: "/profile/" + user.value?.id,
    },
  ];
});

onIonViewWillEnter(() => {
  BarcodeScanner.isSupported().then((result) => {
    const isSupported = result.supported;
    console.log("isSupported==>", isSupported);
  });
});

onIonViewDidLeave(() => menuController.close("menu"));

const openShop = () => {
  window.open("https://beautysku.myshopify.com");
};

const logout = () => {
  userStore.axLogout();
  router.push("/login");
};

const handleClick = async (path: string) => {
  if (path !== "/tabs/menu" && path !== "/tabs/scan") {
    router.push(path);
    return;
  }
};
const handleClose = () => {
  menuController.close("menu");
};
const viewBarcodeResult = async (barcodeResult: any, isFromDB: boolean) => {
  const modal = await modalController.create({
    component: ModalBarcodeScanResult,
    componentProps: { barcodeResult, isFromDB },
  });
  modal.present();
};
const handleScan = async () => {
  try {
    const isAndroid = isPlatform("android");
    //Android Only:
    if (isAndroid) {
      const ress = await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable();
      if (!ress.available) {
        await BarcodeScanner.installGoogleBarcodeScannerModule();
      }
    }

    const { barcodes } = await BarcodeScanner.scan({
      formats: [BarcodeFormat.Ean13, BarcodeFormat.UpcA, BarcodeFormat.UpcE],
    });
    const res = barcodes[0].rawValue;

    //const res = "9780200992930"

    if (res && res != "") {
      const ourDatabaseRes = await productStore.axApiBarcodeLookUp(res);
      if (ourDatabaseRes.id !== "0") {
        // const data = {
        //   id: ourDatabaseRes?.id,
        //   brand: ourDatabaseRes?.brand?.name,
        //   images: [ourDatabaseRes?.url],
        //   title: ourDatabaseRes?.title,
        //   description: ourDatabaseRes?.description,
        //   reviews: ourDatabaseRes?.reviews,
        //   status: ourDatabaseRes?.status,
        // };
        // await viewBarcodeResult(data, true);
        router.push(`/product-detail/${ourDatabaseRes.id}`);
      } else {
        const apiRes = await productStore.axProductBarcodeLookUp(res);
        await viewBarcodeResult(apiRes, false);
      }

      //const resModal = await modalController.create({component:'modalLINK',componentProps:'data: fetchRes'})
    } else {
      alert("Could not find barcode in system");

      const upc = "079400061256"; //"852412007388";

      // }
    }
  } catch (e) {
    alert("Could not find barcode in system");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet), { id: "content" }),
          _createVNode(_unref(IonTabBar), {
            slot: "bottom",
            class: "navbar"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes1.value, (route) => {
                return (_openBlock(), _createBlock(_unref(IonTabButton), {
                  class: "tab-button",
                  selected: path.value == route.path,
                  key: route.id,
                  tab: route.id,
                  onClick: ($event: any) => (_unref(router).push(route.path)),
                  layout: "icon-top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: route.icon
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(console.log(route)) + " ", 1),
                    _createVNode(_unref(IonText), { style: {"font-size":"12px"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(route.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["selected", "tab", "onClick"]))
              }), 128)),
              _createVNode(_unref(IonTabButton), {
                class: "tab-button",
                tab: "scan",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleScan())),
                layout: "icon-top"
              }, {
                default: _withCtx(() => [
                  _cache[11] || (_cache[11] = _createElementVNode("img", {
                    src: _imports_0,
                    style: {"max-height":"40px"}
                  }, null, -1)),
                  _createVNode(_unref(IonLabel), { style: {"font-size":"12px"} }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode(" Scan ")
                    ])),
                    _: 1,
                    __: [10]
                  })
                ]),
                _: 1,
                __: [11]
              }),
              _createVNode(_unref(IonTabButton), {
                class: "tab-button",
                selected: path.value == 'shop',
                key: "shop",
                tab: "shop",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (openShop())),
                layout: "icon-top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(bagHandleOutline) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), { style: {"font-size":"12px"} }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode(" Shop ")
                    ])),
                    _: 1,
                    __: [12]
                  })
                ]),
                _: 1
              }, 8, ["selected"]),
              _createVNode(_unref(IonTabButton), {
                class: "tab-button",
                selected: path.value.indexOf('profile/') > 0 ? true : false,
                key: "mysku",
                tab: "mysku",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push(`/profile/${user.value?.id}`))),
                layout: "icon-top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(personCircleOutline) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), { style: {"font-size":"12px"} }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode(" mySKU ")
                    ])),
                    _: 1,
                    __: [13]
                  })
                ]),
                _: 1
              }, 8, ["selected"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonMenu), {
        side: "start",
        "menu-id": "menu",
        "content-id": "content",
        class: "menu"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonContent), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(IonIcon), {
                  class: "close",
                  icon: _unref(closeOutline),
                  onClick: handleClose
                }, null, 8, ["icon"]),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(IonImg), {
                    src: user.value?.avatar,
                    class: "avatar"
                  }, null, 8, ["src"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", {
                      class: "name",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push(`/profile/${user.value?.id}`)))
                    }, _toDisplayString(`${user.value?.firstName} ${user.value?.lastName}`), 1),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(user.value?.profile.nickName), 1),
                    _createElementVNode("p", {
                      class: "goto-profile",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {
                  _unref(router).push(`/profile/${user.value?.id}`);
                  handleClose();
                })
                    }, " View Profile ")
                  ])
                ]),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => {
                _unref(router).push('/tabs/explore');
                handleClose();
              })
                  }, " Discover "),
                  _createElementVNode("li", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {
                _unref(router).push('/influencerList');
                handleClose();
              })
                  }, " Find Your Tribe "),
                  _createElementVNode("li", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => {
                _unref(router).push('/tabs/events');
                handleClose();
              })
                  }, " Events "),
                  _cache[14] || (_cache[14] = _createElementVNode("li", { class: "shop" }, [
                    _createElementVNode("a", {
                      href: "https://beautysku.myshopify.com/",
                      target: "_blank"
                    }, "Shop   "),
                    _createElementVNode("div", null, [
                      _createElementVNode("i", { class: "fa-thin fa-arrow-up-right-from-square ion-text-right pull-right" })
                    ])
                  ], -1)),
                  _createElementVNode("li", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(router).push('/setting-privacy')))
                  }, " Settings & Privacy "),
                  _createElementVNode("li", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (logout()))
                  }, "Logout")
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "copyright" }, "BeautySKU @2023 - Reserved", -1))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})